import { blueprintFragment, projectFragment } from '@/services/fragments'

export const projectsByOrganizationQuery = /* GraphQL */ `
  query projectsByOrganization(
    $organizationID: ID!
    $filter: ModelProjectFilterInput
    $limit: Int
  ) {
    projectsByOrganization(
      organizationID: $organizationID
      filter: $filter
      limit: $limit
    ) {
      items {
        id
        name
        picture
        endDate
        startDate
        progress
        place {
          id
          name
          location {
            lat
            lon
          }
        }
        organizationID
        members(limit: 1000, filter: { status: { ne: "ARCHIVED" } }) {
          items {
            id
            role
            status
            userID
            member {
              name
            }
          }
        }
        catalogs {
          items {
            id
          }
        }
        blueprints {
          items {
            ...blueprintItem
          }
        }
        updatedAt
      }
    }
  }
  ${blueprintFragment}
`

export const listProjectsAndMembersQuery = /* GraphQL */ `
  query ProjectsAndMembers(
    $userID: ID!
    $filter: ModelOrganizationMemberFilterInput
    $status: ModelStringKeyConditionInput
  ) {
    organizationMemberbyUser(
      userID: $userID
      filter: $filter
      status: $status
      limit: 1000
    ) {
      items {
        id
        projectID
        status
        type
      }
    }
  }
`

export const getProjectQuery = /* GraphQL */ `
  query GetProject($id: ID!) {
    getProject(id: $id) {
      ...projectItem
      blueprints {
        items {
          ...blueprintItem
        }
      }
    }
  }
  ${projectFragment}
  ${blueprintFragment}
`
